import React from "react";
import Card from '@material-ui/core/Card';
import {Objects} from "components";
import API from "@beardeddevops/react.api";
import Types from "../../constants/Types";
import TextField from "@material-ui/core/TextField";
import moment from "moment-timezone";
import CardContent from "@material-ui/core/CardContent";
import {Call_Geocode_API} from "../../constants/Utilities";
import Home from '@material-ui/icons/Home'
import DirectionsCar from '@material-ui/icons/DirectionsCar'

class FELocationTrack extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			refresh: this.props.refresh
		};
	}

	setSelectedFe = async (ticket) => {
		if (ticket) {
			let ticketModel = new API.BuildClass(Types.Tickets._name, 'GET');
			ticketModel.object.pkey = ticket;
			ticketModel = await ticketModel.submit(null, 'GET');

			if (!ticketModel.customers_locations.latitude || !ticketModel.customers_locations.longitude) {
				const loc = ticketModel.customers_locations;
				const geo = await Call_Geocode_API(
					loc.street_1 + ", " + loc.city + " " + loc.state
				);
				if (geo?.latitude != null && geo?.longitude != null) {
					loc.latitude = geo.latitude;
					loc.longitude = geo.longitude;
					let tmodel = new API.BuildClass(Types.Customers_Locations._name, API.RequestType.READ);
					tmodel.parent = ticketModel.customers.pkey;
					tmodel.object = loc;
					tmodel.submit(null, 'POST', true);
				}
			}

			this.setState({ticket: ticketModel, customerPin: {lat: ticketModel.customers_locations.latitude, long: ticketModel.customers_locations.longitude}})
		} else {
			this.setState({ticket: ticket, customerPin: null});
		}
	}

	render() {
		return (
			<div className={'row'}>
				<div className={'col-10'}>
					<Objects.FELocationMap
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						regions={this.props.regions}
						setSelectedFe={this.setSelectedFe}
						customerPin={this.state.customerPin}
					/>
				</div>
				<div className={'col-2'}>
					<h4 className="text-center">Icon Legend</h4>
					<Card>
						<ul style={{display: "block", listStyleType: 'none'}}>
							<li>
								<Home color={'primary'} fontSize={'small'}/>
								<span style={{fontSize: '20px', lineHeight: '12px', display: 'inline-block', fontWeight: 'bold'}}>: Not Active
								</span>
							</li>
							<li>
								<DirectionsCar color={'error'} fontSize={'small'}/>
								<span style={{fontSize: '20px', lineHeight: '12px', display: 'inline-block', fontWeight: 'bold'}}>: On Site</span>
							</li>
							<li>
								<DirectionsCar color={'primary'} fontSize={'small'}/>
								<span style={{fontSize: '20px', lineHeight: '12px', display: 'inline-block', fontWeight: 'bold'}}>: Heading to
								</span>
							</li>
							<li>
								<DirectionsCar color={'secondary'} fontSize={'small'}/>
								<span style={{fontSize: '20px', lineHeight: '12px', display: 'inline-block', fontWeight: 'bold'}}>: Available</span>
							</li>
						</ul>
					</Card>
					{this.state.ticket && <>
						<div className={'col'}>
							<div className={'form-group'}>
								<h5 className="text-center">Current Appointment</h5>
								<Card style={{overflow: 'visible'}}>
									<CardContent style={{paddingBottom: 0}}>
										<div className={"row"}>
											<div className={"col-12"}>
												<div className={"form-group"}>
													<TextField
														fullWidth={true}
														size={"small"}
														label={"Start Time"}
														value={this.state.ticket.appointment_start ? moment(this.state.ticket.appointment_start).format('MM/D/YYYY, h:mm:ss a') : null}
														variant="outlined"
													/>
												</div>
											</div>
											<div className={"col-12"}>
												<div className={"form-group"}>
													<TextField
														fullWidth={true}
														size={"small"}
														label={"End Time"}
														value={this.state.ticket.appointment_end ? moment(this.state.ticket.appointment_end).format('MM/D/YYYY, h:mm:ss a') : null}
														variant="outlined"
													/>
												</div>
											</div>
										</div>
									</CardContent>
								</Card>
							</div>
						</div>
						{/*<div className={'col'}>
							<h4 className="text-center">Current Customer</h4>
						</div>*/}
					</>}
				</div>
			</div>
		)
	}
}

export default FELocationTrack;
